const $ = jQuery;
class NewAcquisition {
    constructor() {
        this.sliderSm = $('.c-slider.cc-latest_acquisition.cc-sm');
        this.sliderLg = $('.c-slider.cc-latest_acquisition.cc-lg');
        this.prevButton = $('.e-slider_btn.cc-prev.cc-latest_acquisition');
        this.nextButton = $('.e-slider_btn.cc-next.cc-latest_acquisition');
        this.init();
    }


    init() {
        if(this.sliderSm.length > 0){
            this.initSliderSm();
        }

        if(this.sliderLg.length > 0){
            this.initSliderLg();
        }
    }

    initSliderSm(){
        // Initialize slick slider
        this.sliderSm.slick({
            slidesToShow: 1.6,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            speed: 300,
            prevArrow: this.prevButton,
            nextArrow: this.nextButton,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    initSliderLg(){
        // Initialize slick slider
        this.sliderLg.slick({
            slidesToScroll: 1,
            variableWidth: false,
            slidesToShow: 2,
            arrows: true,
            dots: false,
            infinite: false,
            speed: 600,
            prevArrow: this.prevButton,
            nextArrow: this.nextButton,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }
}

export default NewAcquisition;
